import React, { createContext, useState, useEffect, useContext, useCallback, useRef } from 'react';
import { useAuth } from './AuthContext';
import { getSocket } from '../socket/socket';
import { enterServicePanel } from '../socket/socketRooms';
import { useSocketEvents } from '../socket/socketEvents';
import { api } from '../api/api';
import Message from '../components/Message';
import { requestForToken, onMessageListener } from '../firebase';
import NotificationPermissionModal from '../components/NotificationPermissionModal';



const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { user, socket } = useAuth();

  // 1. TEKLİFLERİM (AvailableTasks) - Güncel İlanlar
  const [hasNewServiceTasks, setHasNewServiceTasks] = useState(() => {
    return localStorage.getItem('hasNewServiceTasks') === 'true';
  });

  // 1.5 TEKLİFLERİM (AvailableTasks) - Gelen Teklifler
  const [hasIncomingOffers, setHasIncomingOffers] = useState(() => {
    return localStorage.getItem('hasIncomingOffers') === 'true';
  });
  const [hasUpdatedMyOffers, setHasUpdatedMyOffers] = useState(() => {
    return localStorage.getItem('hasUpdatedMyOffers') === 'true';
  });

  // 2. İŞLERİM (MyJobs) İçin Bildirim
  const [hasNewJobs, setHasNewJobs] = useState(() => {
    return localStorage.getItem('hasNewJobs') === 'true';
  });

  // 3. Persistent Notifications (DB)
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // 3.5 Active Chat Room (To silence notifications)
  const [activeChatRoomId, setActiveChatRoomIdState] = useState(null);
  const activeChatRoomIdRef = useRef(null);

  const setActiveChatRoomId = useCallback((id) => {
    setActiveChatRoomIdState(id);
    activeChatRoomIdRef.current = id;
  }, []);

  // 4. Global Toast Messaging
  const [toast, setToast] = useState({ message: null, type: 'success', id: null });

  // 5. App-level notification switch (user toggle)
  const [notificationsEnabled, setNotificationsEnabledState] = useState(() => {
    const stored = localStorage.getItem("notificationsEnabled");
    return stored === null ? true : stored === "true";
  });

  const showToast = useCallback((message, type = 'success') => {
    setToast({ message, type, id: Date.now() });
  }, []);

  const clearToast = useCallback(() => {
    setToast({ message: null, type: 'success', id: null });
  }, []);

  const setNotificationsEnabled = useCallback((enabled) => {
    const normalized = Boolean(enabled);
    setNotificationsEnabledState(normalized);
    localStorage.setItem("notificationsEnabled", String(normalized));

    if (!normalized) {
      setHasNewServiceTasks(false);
      setHasIncomingOffers(false);
      setHasUpdatedMyOffers(false);
      setHasNewJobs(false);
      localStorage.setItem('hasNewServiceTasks', 'false');
      localStorage.setItem('hasIncomingOffers', 'false');
      localStorage.setItem('hasUpdatedMyOffers', 'false');
      localStorage.setItem('hasNewJobs', 'false');
      setShowPermissionModal(false);
    }
  }, []);

  const fetchNotifications = async () => {
    if (!user) return;
    try {
      const res = await api.get(`/notifications`);
      setNotifications(res.data.notifications);
      setUnreadCount(res.data.unreadCount);
    } catch (error) {
      console.error("Bildirimler alınamadı:", error);
    }
  };

  const markNotificationAsRead = async (id) => {
    try {
      await api.put(`/notifications/read/${id}`);
      // State'i güncelle
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, isRead: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Okundu işaretlenemedi:", error);
    }
  };

  const markAllNotificationsAsRead = async () => {
    try {
      await api.put(`/notifications/read/all`);
      setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
      setUnreadCount(0);
    } catch (error) {
      console.error("Tümü okundu işaretlenemedi:", error);
    }
  };

  // Genel okundu işaretleme
  const markAsRead = async (type, groupNotifications = []) => {
    try {
      if (groupNotifications.length > 0) {
        // --- GROUP READ ---
        const idsToMark = groupNotifications.map(n => n.id);
        if (idsToMark.length === 0) return;

        await api.put(`/notifications/read/batch`, { ids: idsToMark });

        // State güncelle
        setNotifications(prev => prev.map(n => idsToMark.includes(n.id) ? { ...n, isRead: true } : n));
        // Unread count azalt (basit matematik: mevcut - okunan sayısı)
        const markedUnreadCount = groupNotifications.filter(n => !n.isRead).length; // Zaten okunanları sayma
        setUnreadCount(prev => Math.max(0, prev - markedUnreadCount));

      } else {
        // --- TYPE BASED READ (Sayfa ziyareti) ---
        let payload = {};
        if (type === 'tasks') payload = { type: 'new_task' };
        else if (type === 'offers') payload = { type: 'new_offer' };
        else if (type === 'myOffers') payload = { type: 'offer_updated' };
        else if (type === 'jobs') payload = { type: 'offer_accepted' }; // veya 'offer_updated' vb. kapsayabilir

        if (payload.type) {
          await api.put(`/notifications/read/batch`, payload);
        }

        // Local kırmızı noktaları temizle
        if (type === 'tasks') {
          setHasNewServiceTasks(false);
          localStorage.setItem('hasNewServiceTasks', 'false');
        } else if (type === 'offers') {
          setHasIncomingOffers(false);
          localStorage.setItem('hasIncomingOffers', 'false');
        } else if (type === 'myOffers') {
          setHasUpdatedMyOffers(false);
          localStorage.setItem('hasUpdatedMyOffers', 'false');
        } else if (type === 'jobs') {
          setHasNewJobs(false);
          localStorage.setItem('hasNewJobs', 'false');
        }

        // Tüm listeyi yenilemek en temizi (sayfa ziyareti olduğu için sorun olmaz)
        fetchNotifications();
      }
    } catch (error) {
      console.error("MarkAsRead Error:", error);
    }
  };


  // === YENİ: BİLDİRİM İZİN YÖNETİMİ ===
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState(
    typeof Notification !== "undefined" ? Notification.permission : "default"
  );

  const refreshPermissionStatus = useCallback(() => {
    if (typeof Notification === "undefined") return;
    setPermissionStatus(Notification.permission);
  }, []);

  const checkPermission = () => {
    if (typeof Notification === "undefined") return;
    if (Notification.permission === 'default') {
      // Henüz sorulmamış, Soft Ask Modalı göster
      // Hemen göstermek yerine kullanıcı biraz gezinsin diye 2sn gecikme ekleyebiliriz
      setTimeout(() => setShowPermissionModal(true), 2000);
    } else if (Notification.permission === 'denied') {
      // Engellenmiş
    }
  };

  const handleAllowNotifications = async () => {
    // Soft Ask'te "İzin Ver"e basıldı, şimdi gerçek tarayıcı iznini iste
    setShowPermissionModal(false);
    await requestForToken();
    refreshPermissionStatus();
  };

  const handleCloseModal = () => {
    setShowPermissionModal(false);
  };
  // ====================================

  useEffect(() => {
    const handleWindowFocus = () => refreshPermissionStatus();
    window.addEventListener("focus", handleWindowFocus);
    document.addEventListener("visibilitychange", handleWindowFocus);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
      document.removeEventListener("visibilitychange", handleWindowFocus);
    };
  }, [refreshPermissionStatus]);

  const deleteNotification = async (id, e) => {
    e.stopPropagation(); // Menünün kapanmasını engelle
    try {
      await api.delete(`/notifications/${id}`);
      setNotifications(prev => prev.filter(n => n.id !== id));
      // Eğer silinen okunmamışsa sayıyı düşür
      const isUnread = notifications.find(n => n.id === id && !n.isRead);
      if (isUnread) setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Silinemedi:", error);
    }
  };


  const clearAllNotifications = async (e) => {
    if (e) e.stopPropagation();
    try {
      await api.delete('/notifications/all');
      setNotifications([]);
      setUnreadCount(0);
    } catch (error) {
      console.error("Tum bildirimler silinemedi:", error);
    }
  };

  const playNotificationSound = (type = 'default') => {
    const soundMap = {
      default: "https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3",
      chat: "https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3",
      offer: "https://assets.mixkit.co/active_storage/sfx/2019/2019-preview.mp3",
      alert: "https://assets.mixkit.co/active_storage/sfx/2354/2354-preview.mp3"
    };

    const audioUrl = soundMap[type] || soundMap.default;
    const audio = new Audio(audioUrl);
    audio.volume = 0.5;
    audio.play().catch(() => { });
  };

  const triggerNotificationUpdate = useCallback((silent = false, soundType = 'default') => {
    if (!notificationsEnabled) return;
    fetchNotifications();
    if (!silent) {
      playNotificationSound(soundType);
    }
  }, [notificationsEnabled, user]);


  // 🔥 Ana Başlatıcı Effect (Tüm bağımlılıklar tanımlandıktan sonra)
  useEffect(() => {
    if (!user) return;
    if (socket) {
      enterServicePanel(socket);

      // Reconnect olduğunda odalara tekrar gir (İnternet kesilip geldiğinde)
      const handleReconnect = () => {
        console.log("🔄 Soket yeniden bağlandı, odalar ve bildirimler yenileniyor...");
        enterServicePanel(socket);
        fetchNotifications(); // Kesinti sırasında kaçan bildirimleri çek
      };

      socket.on('connect', handleReconnect);

      return () => {
        socket.off('connect', handleReconnect);
      };
    }
  }, [user, socket]);

  useEffect(() => {
    if (!user) return;
    fetchNotifications(); // İlk açılışta bildirimleri çek

    // 🔥 Foreground Mesaj Dinleyici (FCM)
    const unsubscribeFCM = onMessageListener((payload) => {
      if (!notificationsEnabled) return;

      // Eğer bu bir chat mesajıysa ve biz o odadaysak toast gösterme
      const data = payload.data || {};
      if (data.type === 'chat_message' && activeChatRoomIdRef.current && Number(data.roomId) === Number(activeChatRoomIdRef.current)) {
        console.log("💬 FCM bildirim susturuldu (aktif sohbet)");
        triggerNotificationUpdate(true);
        return;
      }

      console.log("Bildirim alındı (foreground):", payload);
      showToast(`${payload.notification.title}: ${payload.notification.body}`, 'success');

      // FCM'den gelen tiple sesi belirle
      let soundType = 'default';
      if (data.type === 'chat_message') soundType = 'chat';
      else if (data.type === 'new_offer' || data.type === 'offer_updated') soundType = 'offer';

      triggerNotificationUpdate(false, soundType);
    });

    // İzin durumunu kontrol et ve modalı aç
    if (notificationsEnabled) {
      checkPermission();
    } else {
      setShowPermissionModal(false);
    }

    return () => {
      if (unsubscribeFCM) unsubscribeFCM();
    };
  }, [user, socket, notificationsEnabled, showToast, triggerNotificationUpdate]); // user dependency for fetchNotifications

  const handleTaskEvent = useCallback((data) => {
    if (!notificationsEnabled) return;
    console.log("🔔 Yeni İlan (Hizmet) Geldi:", data);
    setHasNewServiceTasks(true);
    localStorage.setItem('hasNewServiceTasks', 'true');
    triggerNotificationUpdate(false, 'alert');
  }, [notificationsEnabled, triggerNotificationUpdate]);

  const handleOfferEvent = useCallback((data) => {
    if (!notificationsEnabled) return;
    console.log("🔔 Yeni Teklif Geldi:", data);
    setHasIncomingOffers(true);
    localStorage.setItem('hasIncomingOffers', 'true');
    triggerNotificationUpdate(false, 'offer');
  }, [notificationsEnabled, triggerNotificationUpdate]);

  const handleOfferUpdatedEvent = useCallback((data) => {
    if (!notificationsEnabled) return;

    const requiresReview = Number(data?.requiresReview) === 1 || data?.requiresReview === true;
    const belongsToProvider = Number(data?.employeeId) === Number(user?.id);
    const isMyOfferUpdate = requiresReview || belongsToProvider;

    if (isMyOfferUpdate) {
      console.log("🔔 Tekliflerim guncellendi:", data);
      setHasUpdatedMyOffers(true);
      localStorage.setItem('hasUpdatedMyOffers', 'true');
    } else {
      console.log("🔔 Gelen teklif guncellendi:", data);
      setHasIncomingOffers(true);
      localStorage.setItem('hasIncomingOffers', 'true');
    }

    triggerNotificationUpdate(false, 'offer');
  }, [notificationsEnabled, triggerNotificationUpdate, user?.id]);

  const handleJobEvent = useCallback((data) => {
    if (!notificationsEnabled) return;
    console.log("🔔 Yeni İş/Anlaşma Geldi:", data);
    setHasNewJobs(true);
    localStorage.setItem('hasNewJobs', 'true');
    triggerNotificationUpdate(false, 'alert');
  }, [notificationsEnabled, triggerNotificationUpdate]);

  const socketEvents = React.useMemo(() => ({
    // Tekliflerim Sayfası
    onNewTask: handleTaskEvent,
    onNewOffer: handleOfferEvent,
    onOfferUpdated: handleOfferUpdatedEvent,
    onTaskUpdated: handleTaskEvent,

    // İşlerim Sayfası
    onOfferAccepted: handleJobEvent,
    onNewReview: handleJobEvent,

    // Teklif Reddedildi -> Bildirim Göster
    onOfferRejected: (data) => {
      if (!notificationsEnabled) return;
      console.log("🔔 Teklif Reddedildi:", data);
      // İstersek farklı bir badge yakabiliriz veya sadece toast gösterebiliriz
      showToast(data.message || "Teklifiniz reddedildi.", "info");
      // Bildirimleri yenile
      triggerNotificationUpdate(false, 'alert');
    },
    onAgreementCancellationRequested: (data) => {
      if (!notificationsEnabled) return;
      console.log("🔔 İptal İsteği:", data);
      setHasNewJobs(true);
      localStorage.setItem('hasNewJobs', 'true');
      showToast(data.message || "İptal isteği alındı.", "info");
      triggerNotificationUpdate(false, 'alert');
    },

    // Chat Bildirimi
    onNewChatNotification: (data) => {
      if (!notificationsEnabled) return;

      // Eğer sohbet paneli bu oda için açıksa, bildirim/toast gösterme
      if (activeChatRoomIdRef.current && Number(data.roomId) === Number(activeChatRoomIdRef.current)) {
        console.log("💬 Aktif sohbet odası, bildirim susturuldu.");
        triggerNotificationUpdate(true); // Verileri güncelle ama ses çıkarma (ChatWindow kendi sesini çıkarır)
        return;
      }

      console.log("💬 Yeni Chat Mesajı:", data);
      showToast(`💬 ${data.senderName}: ${data.preview}`, "info");
      triggerNotificationUpdate(false, 'chat');
    }
  }), [handleTaskEvent, handleOfferEvent, handleOfferUpdatedEvent, handleJobEvent, notificationsEnabled, showToast, triggerNotificationUpdate]);

  useSocketEvents(socket, socketEvents);

  return (
    <NotificationContext.Provider value={{
      hasNewServiceTasks,
      hasIncomingOffers,
      hasUpdatedMyOffers,
      hasNewJobs,
      markAsRead,
      notifications,
      unreadCount,
      fetchNotifications,
      deleteNotification,
      clearAllNotifications,
      markNotificationAsRead,
      markAllNotificationsAsRead,
      showToast,
      permissionStatus,
      refreshPermissionStatus,
      requestNotificationPermission: handleAllowNotifications,
      notificationsEnabled,
      setNotificationsEnabled,
      activeChatRoomId,
      setActiveChatRoomId,
      // Yeni: Modal tetikleme fonksiyonu (Örn: Ayarlar sayfasından çağırmak için)
      requestPermissionManual: () => setShowPermissionModal(true)
    }}>
      {children}
      <Message
        key={toast.id}
        message={toast.message}
        type={toast.type}
        onClear={clearToast}
      />
      {/* Soft Ask Modalı */}
      <NotificationPermissionModal
        isOpen={showPermissionModal}
        onClose={handleCloseModal}
        onAllow={handleAllowNotifications}
        permissionStatus={permissionStatus}
      />
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotifications bir NotificationProvider içerisinde kullanılmalıdır.");
  }
  return context;
};
